import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import segnalaMancanti from '../../../components/Util/campiMancanti';
import { leggiVersioniMinime, salvaVersioniMinime } from '../../../../api-client/appPlayer';

/*
 * Impostazioni › Versione dell'app (sportid-docs, interventi del 7-8/10/2026, sez. H): il numero di build
 * sotto il quale l'app chiede di aggiornare, prima si cambiava solo con un deploy del backend. Il numero di
 * build e` quello dopo il «+» nella versione dell'app (es. 3.2.0+248 → 248).
 */

const APP = [
    { chiave: 'PLAYER', etichetta: 'App SportID Player' },
    { chiave: 'COACH', etichetta: 'App SportID Coach' },
];

export const VersioneApp = () => {
    const [salvati, setSalvati] = useState(null);
    const [valori, setValori] = useState(null);
    const [errore, setErrore] = useState('');
    const [conferma, setConferma] = useState(false);
    const [salvato, setSalvato] = useState(false);
    const [inCorso, setInCorso] = useState(false);

    useEffect(() => {
        leggiVersioniMinime().then((r) => {
            if (!r || r.error) { setErrore(r?.error || 'Impossibile leggere le versioni.'); return; }
            setSalvati(r);
            setValori(r);
        });
    }, []);
    useEffect(() => {
        if (!salvato) return undefined;
        const t = setTimeout(() => setSalvato(false), 2500);
        return () => clearTimeout(t);
    }, [salvato]);

    const prova = (e) => {
        e.preventDefault();
        // Numero di build mancante o sbagliato: si evidenzia il campo (set-ui «Dati mancanti»)
        const sbagliati = APP
            .filter((a) => !/^\d+$/.test(String(valori[a.chiave])))
            .map((a) => ({ campo: `build-${a.chiave}`, messaggio: String(valori[a.chiave] ?? '').trim() ? 'Il numero di build deve essere un numero intero, senza segni né punti' : 'Manca il numero di build' }));
        if (segnalaMancanti(sbagliati) > 0) return;
        setConferma(true);
    };

    const salva = async () => {
        setConferma(false);
        setInCorso(true);
        const dati = { ...valori, PLAYER: Number(valori.PLAYER), COACH: Number(valori.COACH) };
        const r = await salvaVersioniMinime(dati);
        setInCorso(false);
        if (r?.error) { setErrore(r.error); return; }
        setSalvati(r);
        setValori(r);
        setSalvato(true);
    };

    if (!valori) {
        return errore
            ? <Card><Card.Body>{errore}</Card.Body></Card>
            : <div className="text-center py-5"><Spinner animation="border" role="status" /></div>;
    }

    const alzate = APP.filter((a) => Number(valori[a.chiave]) > Number(salvati[a.chiave]));
    const cambiato = APP.some((a) => String(valori[a.chiave]) !== String(salvati[a.chiave]));

    return (
        <>
            <Modal show={!!errore} onHide={() => setErrore('')} centered>
                <Modal.Header closeButton><Modal.Title>Errore durante l'operazione</Modal.Title></Modal.Header>
                <Modal.Body>{errore}</Modal.Body>
            </Modal>
            <Modal show={conferma} onHide={() => setConferma(false)} centered>
                <Modal.Header closeButton><Modal.Title>Salvare la versione minima?</Modal.Title></Modal.Header>
                <Modal.Body>
                    {alzate.length > 0
                        ? <>Questo blocca gli utenti con una build più vecchia: all'apertura l'app chiederà di aggiornare. Fallo
                            solo quando la nuova versione è già disponibile a tutti su App Store e Google Play.</>
                        : <>Le app con una build da questo numero in su potranno di nuovo entrare.</>}
                </Modal.Body>
                <Modal.Footer>
                    <Button className="btn btn-light btn-add" onClick={() => setConferma(false)}>Annulla</Button>
                    <Button className="btn btn-primary btn-add" onClick={salva}>Salva</Button>
                </Modal.Footer>
            </Modal>
            <Form onSubmit={prova} noValidate>
                <Card>
                    <Card.Body className="sid-card-body--spaced">
                        <h5 className="sid-form-section">Versione minima dell'app</h5>
                        <p className="sid-nota-leggibile">
                            All'apertura l'app manda il suo numero di build: se è più basso di questo, chiede di aggiornare
                            dallo store. Il numero di build è quello dopo il «+» nella versione (3.2.0+248 → 248). Il cambio
                            vale entro un minuto, senza pubblicare niente; chi ha già l'app aperta lo vede alla prossima apertura.
                        </p>
                        <Row className="g-4">
                            {APP.map((a) => (
                                <Col md={4} key={a.chiave}>
                                    <Form.Label htmlFor={`build-${a.chiave}`}>
                                        {a.etichetta} (numero di build) *
                                    </Form.Label>
                                    <Form.Control
                                        id={`build-${a.chiave}`}
                                        type="number"
                                        min={0}
                                        step={1}
                                        style={{ maxWidth: 140 }}
                                        value={valori[a.chiave]}
                                        onChange={(e) => setValori({ ...valori, [a.chiave]: e.target.value })}
                                    />
                                </Col>
                            ))}
                        </Row>
                    </Card.Body>
                </Card>
                <div className="d-flex justify-content-end mt-4">
                    <Button type="submit" className="btn btn-primary" disabled={inCorso || !cambiato}>Salva</Button>
                </div>
            </Form>
            {salvato && <div className="sid-avviso-salvato" role="status">✓ Modifica salvata</div>}
        </>
    );
};

export default VersioneApp;
